import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { watchlistService } from "@/services/userService";

export function useWatchlistIds() {
  const { user } = useAuth();
  return useQuery({ queryKey: ["watchlist-ids", user?.user_id], queryFn: watchlistService.ids, enabled: Boolean(user), staleTime: 60 * 1000 });
}

export function useWatchlist() {
  const { user } = useAuth();
  return useQuery({ queryKey: ["watchlist", user?.user_id], queryFn: watchlistService.list, enabled: Boolean(user), staleTime: 30 * 1000 });
}

export function useToggleWatchlist() {
  const { user } = useAuth();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const key = ["watchlist-ids", user?.user_id];
  const m = useMutation({
    mutationFn: ({ id, on }) => (on ? watchlistService.add(id) : watchlistService.remove(id)),
    onMutate: async ({ id, on }) => {
      await qc.cancelQueries({ queryKey: key });
      const prev = qc.getQueryData(key) || [];
      qc.setQueryData(key, on ? [id, ...prev.filter((x) => x !== id)] : prev.filter((x) => x !== id));
      return { prev };
    },
    onError: (err, _v, ctx) => {
      qc.setQueryData(key, ctx?.prev);
      toast.error(err?.message || "Xatolik yuz berdi");
    },
    onSuccess: (_d, { on }) => {
      toast.success(on ? "Watchlist’ga qo‘shildi" : "Watchlist’dan olib tashlandi");
    },
    onSettled: () => qc.invalidateQueries({ queryKey: ["watchlist", user?.user_id] }),
  });
  return (id, on) => {
    if (!user) {
      toast("Watchlist uchun tizimga kiring");
      navigate("/login", { state: { from: window.location.pathname } });
      return;
    }
    m.mutate({ id, on });
  };
}
